import __request__ from 'routing/request';
interface EntityShareRequest {
    readonly selected_grantee_capabilities: {
        readonly [_key: string]: 'view' | 'manage' | 'own';
    };
}
interface PacksShareRequest {
    readonly pack_ids: string[];
    readonly share_request: EntityShareRequest;
}
/**
 * Add shares for illuminate packs
 */
export function addEntitySharesForPacks(JSONBody: PacksShareRequest): Promise<unknown> {
    return __request__('POST', '/plugins/org.graylog.plugins.illuminate/illuminate_shares/add', JSONBody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Add shares for illuminate pack
 */
export function addEntityShareForPack(pack_id?: string, user_id?: string, capability?: 'VIEW' | 'MANAGE' | 'OWN'): Promise<unknown> {
    return __request__('GET', '/plugins/org.graylog.plugins.illuminate/illuminate_shares/add_for_pack', null, { 'pack_id': pack_id, 'user_id': user_id, 'capability': capability }, {
        'Accept': ['application/json']
    });
}
/**
 * Get installed entities for pack
 */
export function getEntities(packId: string): Promise<unknown> {
    return __request__('GET', `/plugins/org.graylog.plugins.illuminate/illuminate_shares/entities/${packId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Remove shares for illuminate packs
 */
export function removeEntitySharesForPacks(JSONBody: PacksShareRequest): Promise<unknown> {
    return __request__('POST', '/plugins/org.graylog.plugins.illuminate/illuminate_shares/remove', JSONBody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Remove shares for illuminate pack
 */
export function removeEntityShareForPack(pack_id?: string, user_id?: string, capability?: 'VIEW' | 'MANAGE' | 'OWN'): Promise<unknown> {
    return __request__('DELETE', '/plugins/org.graylog.plugins.illuminate/illuminate_shares/remove_for_pack', null, { 'pack_id': pack_id, 'user_id': user_id, 'capability': capability }, {
        'Accept': ['application/json']
    });
}
/**
 * Create / update shares for illuminate packs
 */
export function updateEntitySharesForPacks(JSONBody: PacksShareRequest): Promise<unknown> {
    return __request__('POST', '/plugins/org.graylog.plugins.illuminate/illuminate_shares/update', JSONBody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get shares for pack
 */
export function getShares(packId: string): Promise<unknown> {
    return __request__('GET', `/plugins/org.graylog.plugins.illuminate/illuminate_shares/${packId}`, null, {}, {
        'Accept': ['application/json']
    });
}
